import type { FieldError as FormFieldError, Path, UseFormReturn } from 'react-hook-form';
import { AutosizeTextArea, FieldError, FormField, FormGroup } from '@gonfalon/legacy-forms/components';

import type { CommentFormSchema } from '../schemas';

type SaveChangesCommentFormProps<T extends CommentFormSchema> = {
  form: Pick<UseFormReturn<T>, 'register' | 'formState'>;
};

export function CommentForm<T extends CommentFormSchema>({ form }: SaveChangesCommentFormProps<T>) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <FormGroup name="comment">
      <FormField isRequired={false} label="Comment" name="comment" htmlFor="comment" hint="Add an optional comment">
        <AutosizeTextArea {...register('comment' as Path<T>)} id="comment" name="comment" rows={1} maxRows={4} />
      </FormField>
      <FieldError name="comment" errorMessage={(errors.comment as FormFieldError)?.message} />
    </FormGroup>
  );
}
